/* Foot Design Co — blueprint string grid and 360° spin viewer */
(function () {
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- Blueprint grid: each line is a string that ripples when the pointer crosses it ---------- */
  function initGrid(cv) {
    var host = cv.parentElement;
    var G = 24, S = 8, W = 0, H = 0, d = 1, vLines = [], hLines = [], pt = null, prev = null, drawn = false;
    function mk(count, len) {
      var n = Math.ceil(len / S) + 1, out = [];
      for (var i = 0; i < count; i++) out.push({ u: new Float32Array(n), p: new Float32Array(n), on: false });
      return out;
    }
    function resize() {
      var r = cv.getBoundingClientRect();
      d = window.devicePixelRatio || 1;
      cv.width = Math.max(1, Math.round(r.width * d));
      cv.height = Math.max(1, Math.round(r.height * d));
      W = r.width; H = r.height;
      vLines = mk(Math.floor(W / G) + 1, H);
      hLines = mk(Math.floor(H / G) + 1, W);
      drawn = false;
    }
    function pluck(lines, a0, a1, along) {
      var i0 = Math.floor(a0 / G), i1 = Math.floor(a1 / G);
      if (i0 === i1) return;
      var kick = Math.max(-7, Math.min(7, (a1 - a0) * 0.55));
      for (var i = Math.min(i0, i1) + 1; i <= Math.max(i0, i1); i++) {
        var L = lines[i]; if (!L) continue;
        var k = Math.round(along / S), n = L.u.length;
        for (var j = k - 4; j <= k + 4; j++) {
          if (j <= 0 || j >= n - 1) continue;
          L.p[j] -= kick * Math.exp(-((j - k) * (j - k)) / 5);
        }
        L.on = true;
      }
    }
    function sim(L) {
      var u = L.u, p = L.p, n = u.length, max = 0;
      for (var i = 1; i < n - 1; i++) {
        var v = (2 * u[i] - p[i] + 0.45 * (u[i - 1] - 2 * u[i] + u[i + 1])) * 0.988;
        p[i] = v; var m = v < 0 ? -v : v; if (m > max) max = m;
      }
      L.u = p; L.p = u;
      if (max < 0.02) { L.u.fill(0); L.p.fill(0); L.on = false; }
    }
    function draw() {
      var ctx = cv.getContext('2d');
      ctx.setTransform(d, 0, 0, d, 0, 0);
      ctx.clearRect(0, 0, W, H);
      function line(L, i, vertical) {
        var major = i % 5 === 0;
        ctx.strokeStyle = major ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.12)';
        ctx.lineWidth = major ? 1 : 0.75;
        var pos = i * G + 0.5, len = vertical ? H : W;
        ctx.beginPath();
        if (!L.on) {
          if (vertical) { ctx.moveTo(pos, 0); ctx.lineTo(pos, len); }
          else { ctx.moveTo(0, pos); ctx.lineTo(len, pos); }
        } else {
          for (var j = 0; j < L.u.length; j++) {
            var s = Math.min(j * S, len), off = pos + L.u[j];
            if (vertical) { j === 0 ? ctx.moveTo(off, s) : ctx.lineTo(off, s); }
            else { j === 0 ? ctx.moveTo(s, off) : ctx.lineTo(s, off); }
          }
        }
        ctx.stroke();
      }
      vLines.forEach(function (L, i) { line(L, i, true); });
      hLines.forEach(function (L, i) { line(L, i, false); });
    }
    function step() {
      if (pt && prev && !reduce) {
        pluck(vLines, prev.x, pt.x, pt.y);
        pluck(hLines, prev.y, pt.y, pt.x);
      }
      prev = pt;
      var active = false;
      vLines.forEach(function (L) { if (L.on) { sim(L); active = true; } });
      hLines.forEach(function (L) { if (L.on) { sim(L); active = true; } });
      if (active || !drawn) { draw(); drawn = !active; }
      requestAnimationFrame(step);
    }
    host.addEventListener('pointermove', function (e) {
      var r = cv.getBoundingClientRect();
      pt = { x: e.clientX - r.left, y: e.clientY - r.top };
    });
    host.addEventListener('pointerleave', function () { pt = null; prev = null; });
    host.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse') { pt = null; prev = null; } });
    if (window.ResizeObserver) new ResizeObserver(resize).observe(cv); else window.addEventListener('resize', resize);
    resize();
    requestAnimationFrame(step);
  }

  /* ---------- 360° spin: scrub through frames by drag, buttons or arrow keys ---------- */
  function initSpin(root) {
    var frames;
    try { frames = JSON.parse(root.getAttribute('data-frames') || '[]'); } catch (e) { frames = []; }
    var N = frames.length; if (!N) return;
    var img = root.querySelector('img'), degEl = document.querySelector('[data-spin-deg]');
    var frame = 0, target = null, auto = !reduce, dragging = false, startX = 0, startFrame = 0, last = 0;
    var wrap = function (i) { return ((i % N) + N) % N; };
    frames.forEach(function (src) { var im = new Image(); im.src = src; });
    function show(f) {
      frame = wrap(f);
      img.src = frames[frame];
      if (degEl) degEl.textContent = Math.round((frame / N) * 360) + '°';
    }
    function touch() { auto = false; root.classList.add('is-touched'); }
    root.addEventListener('pointerdown', function (e) {
      touch(); dragging = true; target = null; startX = e.clientX; startFrame = frame;
      if (root.setPointerCapture) root.setPointerCapture(e.pointerId);
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var f = wrap(startFrame - Math.round((e.clientX - startX) / 7));
      if (f !== frame) show(f);
    });
    ['pointerup', 'pointercancel'].forEach(function (t) { root.addEventListener(t, function () { dragging = false; }); });
    function stepBy(n) { touch(); target = (target == null ? frame : target) + n; }
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); stepBy(-3); }
      if (e.key === 'ArrowRight') { e.preventDefault(); stepBy(3); }
    });
    document.querySelectorAll('[data-spin-step]').forEach(function (b) {
      b.addEventListener('click', function () { stepBy(parseInt(b.getAttribute('data-spin-step'), 10)); });
    });
    function tick(t) {
      if (target != null) {
        if (t - last > 28) {
          last = t;
          var goal = wrap(target);
          if (frame === goal) target = null;
          else { var fwd = wrap(goal - frame); show(frame + (fwd <= N / 2 ? 1 : -1)); }
        }
      } else if (auto && t - last > 110) { last = t; show(frame + 1); }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function boot() {
    document.querySelectorAll('[data-foot-grid]').forEach(initGrid);
    document.querySelectorAll('[data-foot-spin]').forEach(initSpin);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
